
import Alert from "@/components/Alert";
import PortfolioKpiCard from "@/components/portfolio/PortfolioKpiCard.vue";
import RealizedKpiCard from "@/components/portfolio/RealizedKpiCard.vue";
import ReturnValueKpiCard from "@/components/portfolio/ReturnValueKpiCard.vue";
import FormatterService from "@/service/FormatterService";
import PortfolioService from '@/service/PortfolioService';

import commonConfig from '@/config/common';

import { backendExceptionHandler, chartIntervalStateHandler, privacyModeTextFormatterMixin, } from '@/mixins';

export default {
    name: "PortfolioKpi",
    components: {
        Alert,
        PortfolioKpiCard,
        ReturnValueKpiCard,
        RealizedKpiCard,
    },
    props: {
        portfolioId: String,
        bus: Object,
        windowTop: Number,
        interval: String,
        selectedPortfolio: Object,
    },
    mixins: [backendExceptionHandler, chartIntervalStateHandler, privacyModeTextFormatterMixin,],

    data() {
        return {
            kpiSwitchStatePerformance: null,
            kpiSwitchStateHolistic: null,
            kpiSwitchStateRoi: null,
            errorMessage: null,
            portfolio: null,
            kpisFrom: null,
            kpisTo: null,
            secondaryTotals: {},
            loading: false,
            showStickyKpiPosition: commonConfig.showStickyKpiPosition,
            format: new FormatterService()
        }
    },

    methods: {
        updateErrorMessage() {
            this.errorMessage = '';
        },
        async fetchTotals() {
            this.loading = true
            this.$store.commit('preferences/setKpiTotalData', {
                loading: true
            })
            return this
                .portfolioService
                .queryTotals(this.portfolioId, this.interval)
                .then(totals => {
                    this.secondaryTotals = totals
                    this.kpisFrom = totals.fromDate
                        ? this.format.date({ date: totals?.fromDate })
                        : null;
                    this.kpisTo = totals.toDate
                        ? this.format.date({ date: totals?.toDate })
                        : null;
                })
                .finally(() => {
                    this.loading = false
                    this.$store.commit('preferences/setKpiTotalData', {
                        loading: false,
                        secondaryTotals: this.secondaryTotals,
                        kpisTo: this.kpisTo,
                        kpisFrom: this.kpisFrom,

                    })
                })
                .catch(e => console.log(e))
        },
    },

    watch: {
        portfolioId() {
            this.fetchTotals()
        },
        interval() {
            this.fetchTotals()
        },
        isSandboxMode: {
            handler(newState) {
                this.portfolioService.setSandboxMode(newState)
            }
        }
    },

    beforeMount() {
        this.fetchTotals()
    },

    created() {
        this.today = new Date()
        this.portfolioService = new PortfolioService(this.$axios, this.$store.state.preferences.isSandboxMode)
        this.$root.$on('kpi-totals-data-updated', this.fetchTotals)
    },

    beforeDestroy() {
        this.$root.$off('kpi-totals-data-updated', this.fetchTotals)
    },
}
